import React from 'react';
import styles from './depositMessage.module.scss';
import { format } from 'date-fns';
import Label, { Palette } from '../../../Label/Label';
export const DepositMessage = ({ firstDeposableDate, handleDeposableDateClick, }) => {
    return (<>
      <div className={styles.warningText}>
        <div className={styles.depositPillWrapper}>
          <Label text='£30 DEPOSIT AVAILABLE' palette={Palette.VIDID_ORANGE}/>
        </div>
        {firstDeposableDate ? (<>
            <span className={styles.depositText}>
              Book your break with a deposit when arrival is 10+ weeks away. Look from{' '}
            </span>
            <button className={styles.deposableBreakButton} onClick={() => handleDeposableDateClick(firstDeposableDate)}>
              {format(firstDeposableDate, 'do MMMM')}.
            </button>
          </>) : (<span className={styles.depositText}>
            Great news! You can secure this break with a deposit.
          </span>)}
      </div>
    </>);
};
